import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { DuplicateObjectErrorItem } from 'src/app/core/models/core.models';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-business-constraints-info',
  templateUrl: './business-constraints-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './business-constraints-info.component.scss',
  imports: [TranslatePipe],
})
export class BusinessConstraintsInfoComponent {
  errors = input<DuplicateObjectErrorItem[]>([]);
}
